module.exports = __webpack_public_path__ + "img/796.6509f56d.jpg";